import React from 'react'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {useMutation} from 'react-query'
import {useQueryResponse} from '../../../core/QueryResponseProvider'
import {updateTask} from '../../../core/_requests'
import {ExpectedDateQuickPicker} from '../../../../project/components/tasks-list/table/columns/ExpectedDateQuickPicker'

type Props = {
  task_id?: number
  task_name?: string
  project_id?: string | number
  creator_id?: string | number
  checklists_count: number
  checklists_concluded_count: number
  attachement_count: number
  tags_count: number
  expected_date: string
  end_date: string
  subtasks_count: number
  sprint_id?: number | null
}

const TaskByUserCountCell = ({
  task_id,
  task_name,
  project_id,
  creator_id,
  checklists_count,
  checklists_concluded_count,
  attachement_count,
  tags_count,
  expected_date,
  end_date,
  subtasks_count,
  sprint_id,
}: Props) => {
  const {refetch} = useQueryResponse()

  const updateExpectedDateMutation = useMutation((date: string | null) =>
    updateTask({
      id: task_id,
      name: task_name,
      project_id: project_id?.toString(),
      creator_id: creator_id?.toString(),
      expected_date: date ?? undefined,
    })
  )

  const handleExpectedDateChange = async (date: string | null) => {
    if (!task_id || task_id === 0) return
    await updateExpectedDateMutation.mutateAsync(date)
    await refetch()
  }

  return (
    <div className='text-center d-flex justify-content-center gap-2'>
      <div className='d-flex gap-4'>
        <div className='d-flex align-items-center gap-1'>
          <OverlayTrigger
            placement='top'
            delay={{show: 50, hide: 100}}
            overlay={
              <Tooltip>
                {checklists_count > 0
                  ? `${checklists_concluded_count + '/' + checklists_count} ${
                      checklists_count == 1 ? 'checklist' : 'checklists'
                    }`
                  : 'Não possui checklist'}
              </Tooltip>
            }
          >
            <i
              className={`bi bi-check-square-fill fs-5 ${checklists_count > 0 && 'text-primary'}`}
            ></i>
          </OverlayTrigger>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <OverlayTrigger
            placement='top'
            delay={{show: 50, hide: 100}}
            overlay={
              <Tooltip>
                {attachement_count > 0
                  ? `${attachement_count} ${attachement_count == 1 ? 'anexo' : 'anexos'}`
                  : 'Não possui anexo'}
              </Tooltip>
            }
          >
            <i className={`bi bi-paperclip fs-5 ${attachement_count > 0 && 'text-primary'}`}></i>
          </OverlayTrigger>
        </div>
        <div className='d-flex align-items-center gap-1'>
          <OverlayTrigger
            placement='top'
            delay={{show: 50, hide: 100}}
            overlay={
              <Tooltip>
                {tags_count > 0
                  ? `${tags_count} ${tags_count == 1 ? 'tag' : 'tags'}`
                  : 'Não possui tag'}
              </Tooltip>
            }
          >
            <i className={`bi bi-tags-fill fs-5 ${tags_count > 0 && 'text-primary'}`}></i>
          </OverlayTrigger>
        </div>

        <div className='d-flex align-items-center gap-1'>
          <OverlayTrigger
            placement='top'
            delay={{show: 50, hide: 100}}
            overlay={
              <Tooltip>
                {subtasks_count > 0
                  ? `${subtasks_count} ${subtasks_count == 1 ? 'subtarefa' : 'subtarefas'}`
                  : 'Não possui subtarefa'}
              </Tooltip>
            }
          >
            <i className={`bi bi-link-45deg fs-5 ${subtasks_count > 0 && 'text-primary'}`}></i>
          </OverlayTrigger>
        </div>

        <div className='d-flex align-items-center gap-1'>
          <ExpectedDateQuickPicker
            expectedDate={expected_date}
            endDate={end_date}
            onSaveDate={handleExpectedDateChange}
            iconSizeClass='fs-5'
          />
        </div>
        <div className='d-flex align-items-center gap-1'>
          <OverlayTrigger
            placement='top'
            delay={{show: 50, hide: 100}}
            overlay={
              <Tooltip>
                {sprint_id !== null && sprint_id !== undefined && sprint_id > 0
                  ? 'Esta tarefa está em uma sprint'
                  : 'Esta tarefa não está em nenhuma sprint'}
              </Tooltip>
            }
          >
            <i
              className={`bi bi-speedometer2 fs-5 ${
                sprint_id !== null && sprint_id !== undefined && sprint_id > 0
                  ? 'text-primary'
                  : ''
              }`}
            ></i>
          </OverlayTrigger>
        </div>
      </div>
    </div>
  )
}

export {TaskByUserCountCell}
